import {Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";
import {RegionAuditLogsComponent} from "./regionAuditLogs.component";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SettingsPersistenceService} from "../../services/settings-persistence.service";
import {LookupService} from "../../srvs/lookup";
import {debounceTime} from "rxjs/operators";
import {SaRegionFilter} from "./sa-region.filter";

@Component({
  selector: 'micro-sa-regions',
  templateUrl: './sa-regions.component.html'
})
export class SaRegionsComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SaRegionFilter = new SaRegionFilter();
  lookups:any;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  pageSettings: SettingsPersistenceService;
  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();

  constructor(protected auth:AuthService,
              private env:EnvService,
              private http:HttpClient,
              private lookupService:LookupService) {
  }

  ngOnInit() {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.regions");
    this.pageSettings
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .init();

    this.reloadDebouncer.pipe(debounceTime(10)).subscribe(change => {
      this.reloadDebounced();
    });

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    this.reloadDebouncer.emit();
  }

  reloadDebounced() {
    let params:HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator.pageIndex || 0))
      .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
    ;

    this.http.get(`${this.env.e.url}/domain/regions`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.length = page.totalElements;
      }
    );
  }

}
